import { useEffect, useState } from 'react';
import ReportMetadata from '../shared/ReportMetadata';
import ReportTable from '../shared/ReportTable';
import { NiiReportContentResponse, ReportsType } from '../shared/types/shared.types';
import { FeaturePlaybookColumns, FeaturePlaybookFilters } from './types/FeaturePlaybook.types';
import { useSwobNotifications } from '../../../../hooks/NotificationsProvider';
import { AxiosError } from 'axios';
import { niiService } from '../../../../services/niiService';
import { useLoader } from '../../../../hooks/useLoader';
import { LOADER_DEBOUNCE_MS } from '../../../../const/global-constants';
import { FeaturePlaybookDialogMetadata, FeaturePlaybookDialogImpactAssessment } from '../Feature_Playbook/types/FeaturePlaybook.types';

interface PropsObject {
  reportId: string;
}

function FeaturePlaybookReport(props: Readonly<PropsObject>) {
  const { addNotifications } = useSwobNotifications();
  const { showLoader, hideLoader } = useLoader();

  const [report, setReport] = useState<NiiReportContentResponse>();

  useEffect(() => {
    if (props.reportId) {
      fetchReport();
    }
  }, []);
  const fetchReport = async () => {
    try {
      showLoader();
      const filter = getFiltersNeeded();
      const response = await niiService.getReportContent(props.reportId, filter);
      setReport(response.data);
    } catch (error) {
      addNotifications([
        {
          title: 'Error',
          icon: 'icon-triangle-warning',
          description:
            error && error instanceof AxiosError ? error.response?.data?.message || error.message : 'An error occurred fetching report',
          timestamp: new Date(),
          color: 'red'
        }
      ]);
    } finally {
      setTimeout(() => hideLoader(), LOADER_DEBOUNCE_MS);
    }
  };

  const getFiltersNeeded = () => {
    const filter = 'page=1&limit=10&filterList=';
    let arr: string[] = [];
    arr = FeaturePlaybookFilters.map((f) => f.attribute);
    return filter + arr.join(',');
  };

  //`Doc: ${metadata.doc_number} | Rev: ${metadata.revision} | Date: ${metadata.date} | Generated: `

  const getMetadataString = (): string => {
    return `Doc: ${report?.documentMetadata?.doc_number} | Rev: ${report?.documentMetadata?.revision} | Date: ${report?.documentMetadata?.date} | Generated: ${report?.documentMetadata?.date}`;
  };

  return (
    <>
      {report && (
        <div className="container">
          <ReportMetadata title={'Feature Playbook'} metadata={getMetadataString()} />
          <br />
          <ReportTable
            type={ReportsType.PLAYBOOK}
            reportId={props.reportId}
            data={report?.data || []}
            report={report}
            filters={FeaturePlaybookFilters}
            columns={FeaturePlaybookColumns}
            clickable={true}
            metadataFields={FeaturePlaybookDialogMetadata}
            impactAssessmentFields={FeaturePlaybookDialogImpactAssessment}
          />
        </div>
      )}
    </>
  );
}
export default FeaturePlaybookReport;
